import React from 'react'
import Experience from './Experience.jsx'

import EXPERIENCE_INTUICION_IMAGE_PATH from 'images/experience_intuicion.jpg'
import EXPERIENCE_INTUICION_SONG_PATH from 'audio/4. RESILIENCIA  MB.mp3'

const IntuicionText = () => (
	<span className="text-center">
		<p>Las sensaciones positivas que te incitan a tomar acción.</p>
		<p>¿Las escuchas?</p>
		<p>Y, ¿al miedo?</p>
		<p>Hay un rugido que está buscando liberarse.</p>
		<p>Tengo el conocimiento de mi eje, mis líneas temporales y mis dolores.</p>
		<p>Tengo un mapa emocional de mi interior.</p>
		<p>Gané profundidad en la compresión de mi complejidad.</p>
		<p>Tomé mi universo en mis manos.</p>
		<p>Ahora es momento de recuperar mi voluntad. Mi deseo.</p>
		<p>Es hora de infundir fuerza.</p>
		<p>De volver a ser actriz de mi intuición.</p>
	</span>
)


const ExperienceIntuicion = (props) => {
	return (<Experience
		image={EXPERIENCE_INTUICION_IMAGE_PATH}
		title={"Intuicion"}
		phrase={"¿Podés bajar el ruido lo suficiente como para escuchar el rugido de tu verdad, esa que no necesita explicaciones y te compele a transitarla?"}
		phrase_rect={{ top: 10, left: 17.5, width: 32, height: 20 }}
		text={<IntuicionText />}
		text_rect={{ top: 50, left: 73, width: 50, height: 85 }}
		text_interaction_zone_rect={{ top: 20, left: 37, width: 8, height: 13 }}
		song={EXPERIENCE_INTUICION_SONG_PATH}
		song_rect={{ top: 57, left: 32, width: 10, height: 10 }}
		{...props}
	/>)		
}

export default ExperienceIntuicion